import React from 'react';
import { HelpCenterSettingsRedirect } from '@atlassian/jira-servicedesk-customer-service-common/src/ui/help-center-settings-redirect/HelpCenterSettingsRedirectOld.tsx';
import type ProjectSettingsServiceDeskTicketTypesField from '@atlassian/jira-spa-apps-project-settings-service-desk-ticket-type-fields/src/ui/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskTicketTypeFields = lazyForPaint<
	typeof ProjectSettingsServiceDeskTicketTypesField
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-ticket-type-fields", jiraSpaEntry: "async-project-settings-service-desk-ticket-type-fields" */ '@atlassian/jira-spa-apps-project-settings-service-desk-ticket-type-fields'
		),
);

const AsyncProjectSettingsServiceDeskTicketTypeFields = (): React.JSX.Element => (
	<HelpCenterSettingsRedirect page="ticket-type-fields">
		<LazyPage
			Page={LazyProjectSettingsServiceDeskTicketTypeFields}
			pageId="project-settings-ticket-type-fields"
			shouldShowSpinner
		/>
	</HelpCenterSettingsRedirect>
);

export default AsyncProjectSettingsServiceDeskTicketTypeFields;
